import { NotFoundComponent } from './components/common/not-found.component';
import { HomeRoutes } from './components/home/home.routes';
import { SignInRoutes } from './components/signin/signin.routes';
import { DashboardRoutes } from './components/dashboard/dashboard.routes';


export const routes: Array<any> = [
  ...HomeRoutes, ...SignInRoutes, ...DashboardRoutes, {path: '**', component: NotFoundComponent}
];



// WEBPACK FOOTER //
// ./src/app/app.routes.ts